import React from "react";

const Image = ({ src, fallback, type = "image/png", alt }) => {
  return (
    <picture>
      <source srcSet={src} type={type} />
      <img src={src} alt={alt} />
    </picture>
  );
};

export default Image;
